import { useIsAuthorized } from '@modules/common/components/CanAccess/hooks';
import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { SetCopyAsDefaultHomeDialogContent } from '@modules/dashboard/components/SetCopyAsDefaultHomeDialogContent';
import { useIsSetAsDefaultHomeEnabled } from '@modules/dashboard/hooks';
import { HomeRounded } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { PermissionOperation, PermissionResource } from 'generated/graphql';

interface SetCopyAsDefaultHomeMenuItemProps {
  closeMenu: () => void;
}

export const SetCopyAsDefaultHomeMenuItem = ({
  closeMenu,
}: SetCopyAsDefaultHomeMenuItemProps) => {
  const { openModal } = useMuiModalContext();

  const isSetAsDefaultHomeEnabled = useIsSetAsDefaultHomeEnabled();

  const canShowSetAsDefaultHomeMenuItem = useIsAuthorized({
    resource: PermissionResource.WorkspaceSettings,
    operation: PermissionOperation.Write,
  });

  if (!isSetAsDefaultHomeEnabled || !canShowSetAsDefaultHomeMenuItem) {
    return null;
  }

  const openSetAsDefaultHomeDialog = () => {
    openModal({
      contentComponent: () => <SetCopyAsDefaultHomeDialogContent />,
      modalProps: {
        fullWidth: true,
        maxWidth: 'sm',
      },
    });
    closeMenu();
  };

  return (
    <MenuItem onClick={openSetAsDefaultHomeDialog}>
      <ListItemIcon>
        <HomeRounded fontSize="small" />
      </ListItemIcon>
      <ListItemText>Set copy as default Home</ListItemText>
    </MenuItem>
  );
};
